import InitialsIcon from './InitialsIcon.styled';

export default InitialsIcon;
